import React, { useEffect, useState } from "react";
import { getStaffList } from "../../../../store/staff/action";
import { getCustomersListData } from "../../../../store/customers/action";
import {
  getTaskPriorityList,
  getTasksCrmITList,
  getTaskStatusListCrmIT,
  getTaskTypeList,
} from "../../../../store/tasksCrmIT/action";
import { getJobsData } from "../../../../store/jobsList/actions";
import { checkListTemplateListActive } from "../../../../store/checkList/action";
import { listVehicles } from "../../../../store/vehicle/action";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Input, Label, ModalBody, Row } from "reactstrap";
import RichTextEditor from "../../../RichTextEditor";
import Select from "../../../Common/AppSelect";
import { isEmpty } from "lodash";
import moment from "moment";
import { AppDateTimePicker } from "../../../Common/AppDateTimePicker";
import {
  flatPickerConvertRawToFormatedDateAndTime,
  timeFormatDateAndTime,
} from "../../../Common/HandleDateTime";

import { handleCalculateHowManyMinutesBetweenTwoDates } from "../../CreateEditTask/CreateEditTaskPopUp";
import { toast } from "react-toastify";
import JobTaskSearchAddress from "./searchAddress";
import { contactPersonList } from "../../../../store/people/action";
import { CustomSelect } from "../../../Common/CustomSelect";

const JobTasks = ({ jobCreateEdit, setJobCreateEdit, initialTaskData }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getStaffList());
    dispatch(getCustomersListData());
    dispatch(getTasksCrmITList());
    dispatch(getTaskStatusListCrmIT());
    dispatch(getTaskPriorityList());
    dispatch(getTaskTypeList());
    dispatch(getJobsData());
    dispatch(checkListTemplateListActive());
    dispatch(listVehicles());
    dispatch(contactPersonList());
  }, []);

  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));

  // get staff members data from state
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));

  const { tasksCrmITList, taskCrmIT, tasksCrmITStatusList } = useSelector(
    (state) => ({
      tasksCrmITList: state.TasksCrmIt.tasksCrmITList?.task_list,
      taskCrmIT: state.TasksCrmIt.taskCrmIT?.task_data,
      tasksCrmITStatusList:
        state.TasksCrmIt.taskStatusListCrmIT?.taskstatus_list,
    })
  );
  const { checklistTemplateActiveAPI } = useSelector((state) => ({
    checklistTemplateActiveAPI:
      state.Checklist.checklistTemplateActive?.taskchecklisttemplate_list,
  }));
  const [popUpUpdateTask, setPopUpUpdateTask] = useState(false);

  const { taskPriorityList, taskTypeList } = useSelector((state) => ({
    taskPriorityList: state.TasksCrmIt.taskPriorityList?.taskpriority_list,
    taskTypeList: state.TasksCrmIt.taskTypeList?.tasktype_list,
  }));

  const { jobsListApi } = useSelector((state) => ({
    jobsListApi: state.Jobs.jobsData?.job_list,
  }));
  const { vehicleListAPI } = useSelector((state) => ({
    vehicleListAPI: state.Vehicle.vehicleList?.vehicle_list,
  }));
  const [isClearEditor, setIsClearEditor] = useState(false);
  const [tempChecklistSelection, setTempChecklistSelection] = useState(null);
  const { PeopleListAPI, contactPersonListLoading } = useSelector((state) => ({
    PeopleListAPI: state.People.contactPersonList?.contactperson_list,
    contactPersonListLoading: state.People.contactPersonListLoading,
  }));

  const handleOnChangeHoursInput = (e, singleTaskCreateUpdate) => {
    // first we check if its a valid number
    if (e.target.value > 23 || e.target.value < 0) {
      toast.error("Please enter a valid number 0-23");
      return;
    }
    // if valid do the math and update duration and EndDateTime
    let newDuration =
      e.target.value * 60 + (+singleTaskCreateUpdate.DurationMins % 60);

    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID === singleTaskCreateUpdate?.LID) {
          return {
            ...task,
            DurationMins: newDuration,
            EndDateTime: timeFormatDateAndTime(
              new Date(
                new Date(singleTaskCreateUpdate.StartDateTime).setMinutes(
                  new Date(singleTaskCreateUpdate.StartDateTime).getMinutes() +
                    newDuration
                )
              )
            ),
          };
        }
        return task;
      }),
    });
  };
  const handleIncreaseDecraeseDurationByHourOrByMinutes = (
    hours,
    minutes,
    singleTaskCreateUpdate
  ) => {
    //first we check get current duration hours and minutes
    let currentHours = Math.floor(singleTaskCreateUpdate.DurationMins / 60);
    let currentMinutes = singleTaskCreateUpdate.DurationMins % 60;
    // check first if its a valid substraction from current duration

    //if valid do the math and update duration and EndDateTime
    let newDuration = (currentHours - hours) * 60 + (currentMinutes - minutes);
    // setSingleTaskCreateUpdate({
    //   ...singleTaskCreateUpdate,
    //   DurationMins: newDuration,
    //   EndDateTime: timeFormatDateAndTime(
    //       new Date(
    //           new Date(singleTaskCreateUpdate.StartDateTime).setMinutes(
    //               new Date(singleTaskCreateUpdate.StartDateTime).getMinutes() +
    //               newDuration
    //           )
    //       )
    //   ),
    // });
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID === singleTaskCreateUpdate?.LID) {
          return {
            ...task,
            DurationMins: newDuration,
            EndDateTime: timeFormatDateAndTime(
              new Date(
                new Date(singleTaskCreateUpdate.StartDateTime).setMinutes(
                  new Date(singleTaskCreateUpdate.StartDateTime).getMinutes() +
                    newDuration
                )
              )
            ),
          };
        }
        return task;
      }),
    });
  };

  const handleOnChangeMinutesInput = (e, singleTaskCreateUpdate) => {
    // first we check if its a valid number
    if (e.target.value > 59 || e.target.value < 0) {
      toast.error("Please enter a valid number 0-59");
      return;
    }
    // if valid do the math and update duration and EndDateTime
    let newDuration =
      Math.floor(singleTaskCreateUpdate.DurationMins / 60) * 60 +
      +e.target.value;
    // setSingleTaskCreateUpdate({
    //   ...singleTaskCreateUpdate,
    //   DurationMins: newDuration,
    //   EndDateTime: timeFormatDateAndTime(
    //       new Date(
    //           new Date(singleTaskCreateUpdate.StartDateTime).setMinutes(
    //               new Date(singleTaskCreateUpdate.StartDateTime).getMinutes() +
    //               newDuration
    //           )
    //       )
    //   ),
    // });
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID === singleTaskCreateUpdate?.LID) {
          return {
            ...task,
            DurationMins: newDuration,
            EndDateTime: timeFormatDateAndTime(
              new Date(
                new Date(singleTaskCreateUpdate.StartDateTime).setMinutes(
                  new Date(singleTaskCreateUpdate.StartDateTime).getMinutes() +
                    newDuration
                )
              )
            ),
          };
        }
        return task;
      }),
    });
  };

  const handleAddNewItemToCheckList = (
    tempChecklistSelection,
    singleTaskCreateUpdate
  ) => {
    if (isEmpty(tempChecklistSelection)) {
      toast.error("Please Select a Checklist Template");
      return;
    }
    // add selected checklist to taskchecklisttemplate_list with new Lid as local id first find if it exist if its not then start with 1 if it dose get max id then + 1
    let newId = 1;
    if (!isEmpty(singleTaskCreateUpdate?.taskchecklisttemplate_list)) {
      newId =
        Math.max(
          ...((singleTaskCreateUpdate?.taskchecklisttemplate_list
            ? singleTaskCreateUpdate?.taskchecklisttemplate_list?.map(
                (item) => item?.Lid
              )
            : [0]) ?? 0)
        ) + 1;
    }

    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID === singleTaskCreateUpdate?.LID) {
          return {
            ...task,
            taskchecklisttemplate_list: [
              ...(task.taskchecklisttemplate_list
                ? task.taskchecklisttemplate_list
                : []),
              {
                Lid: newId,
                TaskChecklistTemplate_Title: tempChecklistSelection?.label,
                TaskChecklistTemplate_Id: tempChecklistSelection?.id,
                isEdit: true,
              },
            ],
          };
        }
        return task;
      }),
    });
  };

  const handleAddNewTask = () => {
    console.log("add New Task to task List");
    // check if taskList is empty then start with 1 if not get max id then + 1
    let newId = 1;
    if (!isEmpty(jobCreateEdit?.taskList)) {
      newId =
        Math.max(
          ...((jobCreateEdit?.taskList
            ? jobCreateEdit?.taskList?.map((item) => item?.LID)
            : [0]) ?? 0)
        ) + 1;
    }
    // add new task to taskList using default from initialTaskData
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID !== newId) {
          return {
            ...task,
            isOpen: false,
          };
        }
        return task;
      }),
    });
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: [
        ...(jobCreateEdit.taskList ? jobCreateEdit.taskList : []),
        {
          ...initialTaskData,
          LID: newId,
          isOpen: true,
        },
      ],
    });
    // set all other tasks to closed once this one is open
  };
  const handleDuplicateTask = (task) => {
    console.log("Duplicate Task", task);
    // check if taskList is empty then start with 1 if not get max id then + 1
    let newId = 1;
    if (!isEmpty(jobCreateEdit?.taskList)) {
      newId =
        Math.max(
          ...((jobCreateEdit?.taskList
            ? jobCreateEdit?.taskList?.map((item) => item?.LID)
            : [0]) ?? 0)
        ) + 1;
    }
    // add new task to taskList using default from initialTaskData
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: jobCreateEdit?.taskList?.map((task, i) => {
        if (task.LID !== newId) {
          return {
            ...task,
            isOpen: false,
          };
        }
        return task;
      }),
    });
    setJobCreateEdit({
      ...jobCreateEdit,
      taskList: [
        ...(jobCreateEdit.taskList ? jobCreateEdit.taskList : []),
        {
          ...task,
          LID: newId,
          isOpen: true,
        },
      ],
    });
  };

  return (
    <>
      <div>
        <h5>Task List</h5>
      </div>
      <div>
        {jobCreateEdit?.taskList?.map((singleTaskCreateUpdate, index) => (
          <div key={index}>
            <Card className={"job-task-header-title p-2"}>
              <div className={"d-flex justify-content-between py-2"}>
                <div>
                  <h5>
                    #{singleTaskCreateUpdate?.LID}{" "}
                    {singleTaskCreateUpdate?.Title}
                  </h5>
                </div>
                <div
                  onClick={() => {
                    //set to oposite
                    setJobCreateEdit({
                      ...jobCreateEdit,
                      taskList: jobCreateEdit?.taskList?.map((task, i) => {
                        if (task.LID === singleTaskCreateUpdate?.LID) {
                          return {
                            ...task,
                            isOpen: !task.isOpen,
                          };
                        }
                        return task;
                      }),
                    });
                  }}
                >
                  {singleTaskCreateUpdate?.isOpen ? (
                    <span title={"Expand"} className={"cursor-pointer"}>
                      <i className="fa-solid fa-caret-down fs-18"></i>
                    </span>
                  ) : (
                    <span title={"Contract"} className={"cursor-pointer"}>
                      <i className="fa-solid fa-caret-up fs-18"></i>
                    </span>
                  )}
                </div>
              </div>
              {singleTaskCreateUpdate?.isOpen && (
                <div>
                  <div>
                    <Row className="g-3">
                      <Col lg={12}>
                        <div>
                          <Label htmlFor="name-field" className="form-label">
                            Task Title
                          </Label>

                          <Input
                            autoFocus={true}
                            name="Title"
                            id="Title"
                            className="form-control"
                            placeholder={`Create Task Title`}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={(e) => {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                taskList: jobCreateEdit?.taskList?.map(
                                  (task, i) => {
                                    if (
                                      task.LID === singleTaskCreateUpdate?.LID
                                    ) {
                                      return {
                                        ...task,
                                        Title: e.target.value,
                                      };
                                    }
                                    return task;
                                  }
                                ),
                              });
                            }}
                            value={singleTaskCreateUpdate.Title || ""}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div>
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Task Description
                          </Label>

                          <RichTextEditor
                            autoFocus={false}
                            initialValue={singleTaskCreateUpdate.Description}
                            placeholder={`Create Task Description`}
                            handleContentChange={(e) => {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                taskList: jobCreateEdit?.taskList?.map(
                                  (task, i) => {
                                    if (
                                      task.LID === singleTaskCreateUpdate?.LID
                                    ) {
                                      return {
                                        ...task,
                                        Description: e,
                                      };
                                    }
                                    return task;
                                  }
                                ),
                              });
                            }}
                            receivedContent={taskCrmIT?.Description}
                            isClearEditor={isClearEditor}
                            setIsClearEditor={setIsClearEditor}
                          />
                        </div>
                      </Col>
                      <Col lg={6}>
                        <Label>Contact Person</Label>

                        <CustomSelect
                          value={
                            singleTaskCreateUpdate?.ContactPerson_Id &&
                            singleTaskCreateUpdate?.ContactPerson_Id +
                              " " +
                              PeopleListAPI?.find(
                                (item) =>
                                  item.Id ===
                                  singleTaskCreateUpdate?.ContactPerson_Id
                              )?.Title
                          }
                          placeholder={
                            singleTaskCreateUpdate?.ContactPerson_Id
                              ? (singleTaskCreateUpdate?.ContactPerson_Id +
                                  " " +
                                  PeopleListAPI?.find(
                                    (item) =>
                                      item.Id ===
                                      singleTaskCreateUpdate?.ContactPerson_Id
                                  )?.FullName: "")
                              : "Select..."
                          }
                          onClickCallBack={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              taskList: jobCreateEdit?.taskList?.map(
                                (task, i) => {
                                  if (
                                    task.LID === singleTaskCreateUpdate?.LID
                                  ) {
                                    return {
                                      ...task,
                                      ContactPerson_Id: e?.id,
                                    };
                                  }
                                  return task;
                                }
                              ),
                            });
                          }}
                          options={
                            !isEmpty(PeopleListAPI)
                              ? PeopleListAPI?.map((item) => ({
                                  firstLine: {
                                    label:
                                      "#" + item?.Id + " " + item?.FullName,
                                  },
                                  secondLine: {
                                    label:
                                      item?.contactpersonemailaddress_list
                                        ?.length > 0
                                        ? "Email: " +
                                          item?.contactpersonemailaddress_list
                                            ?.map(
                                              (email) => email?.EmailAddress
                                            )
                                            .join(", ")
                                        : "",
                                  },
                                  thirdLine: {
                                    label:
                                      item?.contactpersontelephonenumber_list
                                        ?.length > 0
                                        ? "Phone Nr: " +
                                          item?.contactpersontelephonenumber_list
                                            ?.map(
                                              (email) => email?.TelephoneNumber
                                            )
                                            .join(", ")
                                        : "",
                                  },
                                  value: item?.Id,
                                  id: item?.Id,
                                  item,
                                }))
                              : []
                          }
                        />
                      </Col>

                      <Col lg={6}>
                        <div>
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Task Status
                          </Label>

                          <div>
                            <Select
                              isClearable={true}
                              className="mb-0 job-select2"
                              value={{
                                label: tasksCrmITStatusList?.find(
                                  (item) =>
                                    item.Id ===
                                    singleTaskCreateUpdate.TaskStatus_Id
                                )?.Name,
                                value: singleTaskCreateUpdate.TaskStatus_Id,
                                id: singleTaskCreateUpdate.TaskStatus_Id,
                              }}
                              onChange={(e) => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          TaskStatus_Id: e.id,
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              options={
                                !isEmpty(tasksCrmITStatusList)
                                  ? tasksCrmITStatusList.map((item) => ({
                                      label: item.Name,
                                      value: item.Id,
                                      id: item.Id,
                                    }))
                                  : []
                              }
                              id="country-select"
                            ></Select>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Task Type
                          </Label>

                          <div>
                            <Select
                              isClearable={true}
                              className="mb-0 job-select2"
                              value={{
                                label: taskTypeList?.find(
                                  (item) =>
                                    item.Id ===
                                    singleTaskCreateUpdate.TaskType_Id
                                )?.Name,
                                value: singleTaskCreateUpdate.TaskType_Id,
                                id: singleTaskCreateUpdate.TaskType_Id,
                              }}
                              onChange={(e) => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          TaskType_Id: e.id,
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              options={
                                !isEmpty(taskTypeList)
                                  ? taskTypeList?.map((item) => ({
                                      label: item?.Name,
                                      value: item?.Id,
                                      id: item?.Id,
                                    }))
                                  : []
                              }
                              id="country-select"
                            ></Select>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Task Priority
                          </Label>

                          <div>
                            <Select
                              isClearable={true}
                              className="mb-0 job-select2"
                              value={{
                                label: taskPriorityList?.find(
                                  (item) =>
                                    item.Id ===
                                    singleTaskCreateUpdate.TaskPriority_Id
                                )?.Name,
                                value: singleTaskCreateUpdate.TaskPriority_Id,
                                id: singleTaskCreateUpdate.TaskPriority_Id,
                              }}
                              onChange={(e) => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          TaskPriority_Id: e.id,
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              options={
                                !isEmpty(taskPriorityList)
                                  ? taskPriorityList?.map((item) => ({
                                      label: item?.Name,
                                      value: item?.Id,
                                      id: item?.Id,
                                    }))
                                  : []
                              }
                              id="country-select"
                            ></Select>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label>Start</Label>
                          <div className={"d-flex d-inline-flex w-100"}>
                            <AppDateTimePicker
                              value={
                                singleTaskCreateUpdate.StartDateTime
                                  ? moment(singleTaskCreateUpdate.StartDateTime)
                                  : null
                              }
                              views={
                                singleTaskCreateUpdate?.FlagAllDay === "1"
                                  ? ["year", "month", "day"]
                                  : undefined
                              }
                              onChange={(val) => {
                                const jsDate =
                                  val && val.isValid() ? val.toDate() : null;
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          StartDateTime: jsDate
                                            ? flatPickerConvertRawToFormatedDateAndTime(
                                                jsDate
                                              )
                                            : "",
                                          // recalculate duration
                                          DurationMins:
                                            singleTaskCreateUpdate.EndDateTime &&
                                            jsDate
                                              ? handleCalculateHowManyMinutesBetweenTwoDates(
                                                  new Date(
                                                    singleTaskCreateUpdate.EndDateTime
                                                  ),
                                                  new Date(
                                                    timeFormatDateAndTime(jsDate)
                                                  )
                                                )
                                              : null,
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              slotProps={{
                                textField: { placeholder: "Select Start date" },
                              }}
                            />
                            <button
                              onClick={() => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          StartDateTime: "",
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              className={"btn btn-danger"}
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div>
                          <Label>End</Label>
                          <div className={"d-flex d-inline-flex w-100"}>
                            <AppDateTimePicker
                              value={
                                singleTaskCreateUpdate.EndDateTime
                                  ? moment(singleTaskCreateUpdate.EndDateTime)
                                  : null
                              }
                              views={
                                singleTaskCreateUpdate?.FlagAllDay === "1"
                                  ? ["year", "month", "day"]
                                  : undefined
                              }
                              onChange={(val) => {
                                const jsDate =
                                  val && val.isValid() ? val.toDate() : null;
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          EndDateTime: jsDate
                                            ? flatPickerConvertRawToFormatedDateAndTime(
                                                jsDate
                                              )
                                            : "",
                                          // recalculate duration
                                          DurationMins:
                                            singleTaskCreateUpdate.StartDateTime &&
                                            jsDate
                                              ? handleCalculateHowManyMinutesBetweenTwoDates(
                                                  new Date(
                                                    singleTaskCreateUpdate.StartDateTime
                                                  ),
                                                  new Date(
                                                    timeFormatDateAndTime(jsDate)
                                                  )
                                                )
                                              : null,
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              slotProps={{
                                textField: { placeholder: "Select End date" },
                              }}
                            />
                            <button
                              onClick={() => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  taskList: jobCreateEdit?.taskList?.map(
                                    (task, i) => {
                                      if (
                                        task.LID === singleTaskCreateUpdate?.LID
                                      ) {
                                        return {
                                          ...task,
                                          EndDateTime: "",
                                        };
                                      }
                                      return task;
                                    }
                                  ),
                                });
                              }}
                              className={"btn btn-danger"}
                            >
                              <i className="fa-solid fa-xmark"></i>
                            </button>
                          </div>
                        </div>
                      </Col>
                      {singleTaskCreateUpdate?.FlagAllDay === "0" && (
                        <Col lg={3}>
                          <div>
                            <Label>Duration</Label>
                            <div className={"d-flex d-inline-flex w-100"}>
                              <div
                                className={"d-flex flex-row align-items-center"}
                              >
                                <div
                                  className={
                                    "d-flex flex-row align-items-center"
                                  }
                                >
                                  <input
                                    className={"time-duration-input"}
                                    type={"number"}
                                    placeholder={"Hrs.."}
                                    value={
                                      // convert min to hours and keep hours only
                                      Math.floor(
                                        singleTaskCreateUpdate.DurationMins / 60
                                      ) ?? 0
                                    }
                                    onChange={(e) => {
                                      handleOnChangeHoursInput(
                                        e,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                  />
                                </div>
                                <div
                                  className={"time-up-and-down-cursor-block"}
                                >
                                  <span
                                    title={"+1 Hour"}
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                      handleIncreaseDecraeseDurationByHourOrByMinutes(
                                        -1,
                                        0,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                  >
                                    <i className="fa-solid fa-caret-up"></i>
                                  </span>
                                  <span
                                    title={"-1 Hour"}
                                    onClick={() => {
                                      handleIncreaseDecraeseDurationByHourOrByMinutes(
                                        1,
                                        0,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                    className={"cursor-pointer"}
                                  >
                                    <i className="fa-solid fa-caret-down"></i>
                                  </span>
                                </div>
                                <div>
                                  <span className={"fs-24 fw-bold mx-2"}>
                                    :
                                  </span>
                                </div>
                                <div
                                  className={
                                    "d-flex flex-row align-items-center  "
                                  }
                                >
                                  <input
                                    className={"time-duration-input"}
                                    type={"number"}
                                    placeholder={"Mins.."}
                                    value={
                                      // convert min to hours and keep hours only
                                      singleTaskCreateUpdate.DurationMins %
                                        60 ?? 0
                                    }
                                    onChange={(e) => {
                                      handleOnChangeMinutesInput(
                                        e,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                  />{" "}
                                </div>
                                <div
                                  className={"time-up-and-down-cursor-block"}
                                >
                                  <span
                                    title={"+1 Min"}
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                      handleIncreaseDecraeseDurationByHourOrByMinutes(
                                        0,
                                        -1,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                  >
                                    <i className="fa-solid fa-caret-up"></i>
                                  </span>
                                  <span
                                    title={"-1 Min"}
                                    className={"cursor-pointer"}
                                    onClick={() => {
                                      handleIncreaseDecraeseDurationByHourOrByMinutes(
                                        0,
                                        1,
                                        singleTaskCreateUpdate
                                      );
                                    }}
                                  >
                                    <i className="fa-solid fa-caret-down"></i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col
                        lg={singleTaskCreateUpdate?.FlagAllDay === "1" ? 4 : 1}
                        className={"text-end"}
                      >
                        <Label>All Day</Label>
                        <div
                          className={"d-flex justify-content-end "}
                          style={{ marginTop: "10px" }}
                        >
                          <input
                            type="checkbox"
                            className=" form-check-input  "
                            checked={singleTaskCreateUpdate.FlagAllDay === "1"}
                            onChange={(e) => {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                taskList: jobCreateEdit?.taskList?.map(
                                  (task, i) => {
                                    if (
                                      task.LID === singleTaskCreateUpdate?.LID
                                    ) {
                                      return {
                                        ...task,
                                        FlagAllDay:
                                          singleTaskCreateUpdate.FlagAllDay ===
                                          "1"
                                            ? "0"
                                            : "1",
                                      };
                                    }
                                    return task;
                                  }
                                ),
                              });
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={12}>
                        <Label>Select Checklist</Label>
                        <Row>
                          <Col lg={9}>
                            {" "}
                            <Select
                              style={{ width: "70%" }}
                              placeholder="Select Checklist"
                              isClearable={true}
                              className="mb-0 "
                              value={
                                tempChecklistSelection
                                  ? tempChecklistSelection
                                  : null
                              }
                              onChange={(e) => {
                                //if e is null then set null otherwise set e.id
                                setTempChecklistSelection(e ? e : null);
                              }}
                              options={
                                !isEmpty(checklistTemplateActiveAPI)
                                  ? checklistTemplateActiveAPI?.map((item) => ({
                                      label: item?.Title,
                                      value: item?.Id,
                                      id: item?.Id,
                                    }))
                                  : []
                              }
                            ></Select>
                          </Col>
                          <Col lg={3}>
                            <button
                              className={"btn btn-success w-100"}
                              onClick={() => {
                                handleAddNewItemToCheckList(
                                  tempChecklistSelection,
                                  singleTaskCreateUpdate
                                );
                              }}
                            >
                              Add Checklist
                            </button>
                          </Col>
                        </Row>
                        {!isEmpty(
                          singleTaskCreateUpdate?.taskchecklisttemplate_list
                        ) && (
                          <Row className={"mt-2"}>
                            {singleTaskCreateUpdate?.taskchecklisttemplate_list?.map(
                              (checklist, index) => (
                                <Col
                                  lg={4}
                                  key={
                                    checklist?.TaskChecklistTemplate_Id + index
                                  }
                                >
                                  <Card className={"p-2"}>
                                    <div
                                      className={
                                        "d-flex justify-content-between  "
                                      }
                                    >
                                      <div>
                                        <div>
                                          {
                                            checklist?.TaskChecklistTemplate_Title
                                          }
                                        </div>
                                      </div>
                                      <div>
                                        <div>
                                          <button
                                            onClick={() => {
                                              // setSingleTaskCreateUpdate({
                                              //   ...singleTaskCreateUpdate,
                                              //   taskchecklisttemplate_list:
                                              //     singleTaskCreateUpdate?.taskchecklisttemplate_list.filter(
                                              //       (item) =>
                                              //         item?.Lid !==
                                              //         checklist?.Lid
                                              //     ),
                                              // });
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                taskList:
                                                  jobCreateEdit?.taskList?.map(
                                                    (task, i) => {
                                                      if (
                                                        task.LID ===
                                                        singleTaskCreateUpdate?.LID
                                                      ) {
                                                        return {
                                                          ...task,
                                                          taskchecklisttemplate_list:
                                                            task?.taskchecklisttemplate_list.filter(
                                                              (item) =>
                                                                item?.Lid !==
                                                                checklist?.Lid
                                                            ),
                                                        };
                                                      }
                                                      return task;
                                                    }
                                                  ),
                                              });
                                            }}
                                            className={
                                              "btn btn-sm btn-soft-danger"
                                            }
                                          >
                                            <i className="fa-regular fa-square-minus"></i>
                                          </button>
                                        </div>
                                        <div>
                                          <button
                                            onClick={() => {
                                              // toggle isEdit
                                              // setSingleTaskCreateUpdate({
                                              //   ...singleTaskCreateUpdate,
                                              //   taskchecklisttemplate_list:
                                              //     singleTaskCreateUpdate?.taskchecklisttemplate_list.map(
                                              //       (item) =>
                                              //         item?.Lid ===
                                              //         checklist?.Lid
                                              //           ? {
                                              //               ...item,
                                              //               isEdit:
                                              //                 !item?.isEdit,
                                              //             }
                                              //           : item
                                              //     ),
                                              // });
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                taskList:
                                                  jobCreateEdit?.taskList?.map(
                                                    (task, i) => {
                                                      if (
                                                        task.LID ===
                                                        singleTaskCreateUpdate?.LID
                                                      ) {
                                                        return {
                                                          ...task,
                                                          taskchecklisttemplate_list:
                                                            task?.taskchecklisttemplate_list.map(
                                                              (item) =>
                                                                item?.Lid ===
                                                                checklist?.Lid
                                                                  ? {
                                                                      ...item,
                                                                      isEdit:
                                                                        !item?.isEdit,
                                                                    }
                                                                  : item
                                                            ),
                                                        };
                                                      }
                                                      return task;
                                                    }
                                                  ),
                                              });
                                            }}
                                            className={
                                              "btn btn-sm btn-soft-warning"
                                            }
                                          >
                                            <i className="fa-regular fa-pen-to-square"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </Card>
                                </Col>
                              )
                            )}
                          </Row>
                        )}
                      </Col>
                      <Col lg={12}>
                        <JobTaskSearchAddress
                          taskData={singleTaskCreateUpdate}
                          allData={jobCreateEdit}
                          setTaskData={setJobCreateEdit}
                        />
                      </Col>
                      <Col lg={12}>
                        <div>
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Due Date
                          </Label>

                          <div>
                            <div className={"d-flex d-inline-flex w-100"}>
                              <AppDateTimePicker
                                value={
                                  singleTaskCreateUpdate.DueDateTime
                                    ? moment(singleTaskCreateUpdate.DueDateTime)
                                    : null
                                }
                                onChange={(val) => {
                                  const jsDate =
                                    val && val.isValid() ? val.toDate() : null;
                                  setJobCreateEdit({
                                    ...jobCreateEdit,
                                    taskList: jobCreateEdit?.taskList?.map(
                                      (task, i) => {
                                        if (
                                          task.LID ===
                                          singleTaskCreateUpdate?.LID
                                        ) {
                                          return {
                                            ...task,
                                            DueDateTime: jsDate
                                              ? flatPickerConvertRawToFormatedDateAndTime(
                                                  jsDate
                                                )
                                              : "",
                                          };
                                        }
                                        return task;
                                      }
                                    ),
                                  });
                                }}
                                slotProps={{
                                  textField: { placeholder: "Select Due date" },
                                }}
                              />
                              <button
                                onClick={() => {
                                  // setSingleTaskCreateUpdate({
                                  //   ...singleTaskCreateUpdate,
                                  //   DueDateTime: "",
                                  // });
                                  setJobCreateEdit({
                                    ...jobCreateEdit,
                                    taskList: jobCreateEdit?.taskList?.map(
                                      (task, i) => {
                                        if (
                                          task.LID ===
                                          singleTaskCreateUpdate?.LID
                                        ) {
                                          return {
                                            ...task,
                                            DueDateTime: "",
                                          };
                                        }
                                        return task;
                                      }
                                    ),
                                  });
                                }}
                                className={"btn btn-danger"}
                              >
                                <i className="fa-solid fa-xmark"></i>
                              </button>
                            </div>
                            <div
                              className={"pt-2 d-flex justify-content-center"}
                            >
                              <div className={"p-2"}>
                                <button
                                  className={"btn btn-soft-success"}
                                  onClick={() => {
                                    // setSingleTaskCreateUpdate({
                                    //   ...singleTaskCreateUpdate,
                                    //   // Today
                                    //   DueDateTime:
                                    //     flatPickerConvertRawToFormatedDateAndTime(
                                    //       [new Date()]
                                    //     ),
                                    // });
                                    setJobCreateEdit({
                                      ...jobCreateEdit,
                                      taskList: jobCreateEdit?.taskList?.map(
                                        (task, i) => {
                                          if (
                                            task.LID ===
                                            singleTaskCreateUpdate?.LID
                                          ) {
                                            return {
                                              ...task,
                                              // Today
                                              DueDateTime:
                                                flatPickerConvertRawToFormatedDateAndTime(
                                                  [new Date()]
                                                ),
                                            };
                                          }
                                          return task;
                                        }
                                      ),
                                    });
                                  }}
                                >
                                  Today
                                </button>
                              </div>
                              <div className={"p-2"}>
                                <button
                                  onClick={() => {
                                    // setSingleTaskCreateUpdate({
                                    //   ...singleTaskCreateUpdate,
                                    //   // Tomorrow + 1 day
                                    //   DueDateTime:
                                    //     flatPickerConvertRawToFormatedDateAndTime(
                                    //       [
                                    //         new Date(
                                    //           new Date().setDate(
                                    //             new Date().getDate() + 1
                                    //           )
                                    //         ),
                                    //       ]
                                    //     ),
                                    // });
                                    setJobCreateEdit({
                                      ...jobCreateEdit,
                                      taskList: jobCreateEdit?.taskList?.map(
                                        (task, i) => {
                                          if (
                                            task.LID ===
                                            singleTaskCreateUpdate?.LID
                                          ) {
                                            return {
                                              ...task,
                                              // Tomorrow + 1 day
                                              DueDateTime:
                                                flatPickerConvertRawToFormatedDateAndTime(
                                                  [
                                                    new Date(
                                                      new Date().setDate(
                                                        new Date().getDate() + 1
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            };
                                          }
                                          return task;
                                        }
                                      ),
                                    });
                                  }}
                                  className={"btn btn-soft-info"}
                                >
                                  Tomorrow
                                </button>
                              </div>
                              <div className={"p-2"}>
                                <button
                                  onClick={() => {
                                    // setSingleTaskCreateUpdate({
                                    //   ...singleTaskCreateUpdate,
                                    //   // + 1 Week
                                    //   DueDateTime:
                                    //     flatPickerConvertRawToFormatedDateAndTime(
                                    //       [
                                    //         new Date(
                                    //           new Date().setDate(
                                    //             new Date().getDate() + 7
                                    //           )
                                    //         ),
                                    //       ]
                                    //     ),
                                    // });
                                    setJobCreateEdit({
                                      ...jobCreateEdit,
                                      taskList: jobCreateEdit?.taskList?.map(
                                        (task, i) => {
                                          if (
                                            task.LID ===
                                            singleTaskCreateUpdate?.LID
                                          ) {
                                            return {
                                              ...task,
                                              // + 1 Week
                                              DueDateTime:
                                                flatPickerConvertRawToFormatedDateAndTime(
                                                  [
                                                    new Date(
                                                      new Date().setDate(
                                                        new Date().getDate() + 7
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            };
                                          }
                                          return task;
                                        }
                                      ),
                                    });
                                  }}
                                  className={"btn btn-soft-primary"}
                                >
                                  1 Week
                                </button>
                              </div>
                              <div className={"p-2"}>
                                <button
                                  onClick={() => {
                                    // setSingleTaskCreateUpdate({
                                    //   ...singleTaskCreateUpdate,
                                    //   // add exactly + 1 month to current date if current date is 31st of any month then it will add 1 month and 1 day
                                    //   DueDateTime:
                                    //     flatPickerConvertRawToFormatedDateAndTime(
                                    //       [
                                    //         new Date(
                                    //           new Date().setMonth(
                                    //             new Date().getMonth() + 1
                                    //           )
                                    //         ),
                                    //       ]
                                    //     ),
                                    // });
                                    setJobCreateEdit({
                                      ...jobCreateEdit,
                                      taskList: jobCreateEdit?.taskList?.map(
                                        (task, i) => {
                                          if (
                                            task.LID ===
                                            singleTaskCreateUpdate?.LID
                                          ) {
                                            return {
                                              ...task,
                                              // add exactly + 1 month to current date if current date is 31st of any month then it will add 1 month and 1 day
                                              DueDateTime:
                                                flatPickerConvertRawToFormatedDateAndTime(
                                                  [
                                                    new Date(
                                                      new Date().setMonth(
                                                        new Date().getMonth() +
                                                          1
                                                      )
                                                    ),
                                                  ]
                                                ),
                                            };
                                          }
                                          return task;
                                        }
                                      ),
                                    });
                                  }}
                                  className={"btn btn-soft-secondary"}
                                >
                                  1 Month
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}
              <div>
                <div className={"d-flex justify-content-end"}>
                  <button
                    onClick={() => {
                      handleDuplicateTask(singleTaskCreateUpdate);
                    }}
                    className={
                      "btn btn-primary d-flex align-items-center mt-2 me-2"
                    }
                  >
                    <i className="fa-solid fa-copy me-2"></i>
                    Duplicate Task
                  </button>
                  <button
                    onClick={() => {
                      // remove task
                      setJobCreateEdit({
                        ...jobCreateEdit,
                        taskList: jobCreateEdit?.taskList?.filter(
                          (task) => task.LID !== singleTaskCreateUpdate?.LID
                        ),
                      });
                    }}
                    className={"btn btn-danger d-flex align-items-center mt-2"}
                  >
                    <i className="fa-solid fa-trash me-2"></i>
                    Remove Task
                  </button>
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
      <div className={"mt-2 d-flex "}>
        <button
          onClick={() => {
            handleAddNewTask();
          }}
          className={"btn btn-primary"}
        >
          Add New Task
        </button>
      </div>
    </>
  );
};
export default JobTasks;
